import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

@Component({
    selector: 'app-edit-organization-save-modal',
    templateUrl: './edit-organization-save-modal.component.html',
    styleUrls: ['./edit-organization-save-modal.component.scss'],
})
export class EditOrganizationSaveModalComponent {
    @Input() modalMessage: string;
    @ViewChild('message') dialogMessage: ElementRef;

    constructor(private ngbActiveModal: NgbActiveModal) {}

    ngAfterViewInit(): void {
        this.dialogMessage.nativeElement.innerHTML = this.modalMessage;
    }

    closeModal() {
        this.ngbActiveModal.close();
    }

    okClick() {
        this.ngbActiveModal.close(true);
    }
}
